/**
 * Explicitly checks for null and undefined.
 * @param {any} val - The thing to check
 */
export const isNullOrUndefined = (val: any): boolean => val === null || typeof val === 'undefined';

/**
 * Capitalizes the first letter of a string
 * @param {string} s - The string to have its first letter capitalized
 */
export const capitalize = (s: string): string => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
